import { useTranslate } from "ra-core";
import { SearchInput } from "@/components/admin/search-input";

export interface TextFilterProps {
  source: string;
  /** Shown as the placeholder and in the « Ajouter un filtre » menu. */
  label: string;
  alwaysOn?: boolean;
}

/** Text filter of the list's top bar, e.g. a custom text field that contains a word. */
export const TextFilter = ({ source, label }: TextFilterProps) => {
  const translate = useTranslate();
  return (
    <SearchInput
      source={source}
      placeholder={translate(label, { _: label })}
      className="w-48"
    />
  );
};
